import { useCallback, useEffect } from 'react';
import { usePathname } from '@/lib/router';
import { sendEpisodEvent, setEpisodContext } from '../utils/episod';

enum EventType {
  ContentView = 'CONTENT_VIEW',
  PageView = 'PAGE_VIEW',
  UserAction = 'USER_ACTION',
}

const getQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  return Object.fromEntries(searchParams);
};

// "PAGE_VIEW" event
export const useRouteTracking = () => {
  const pathname = usePathname();

  useEffect(() => {
    const data = {
      path: pathname,
      queryParams: getQueryParams(),
    };

    sendEpisodEvent({
      event_name: EventType.PageView,
      event_details: data,
    });
  }, [pathname]);
};

// "CONTENT_VIEW" event
export const useContentTracking = () => {
  const pathname = usePathname();

  return useCallback(
    (content: string, extraArgs = {}) => {
      const data = {
        path: pathname,
        queryParams: getQueryParams(),
        content,
        ...extraArgs,
      };

      sendEpisodEvent({
        event_name: EventType.ContentView,
        event_details: data,
      });
    },
    [pathname]
  );
};

// "USER_INTERACTION" event
export const useInteractionTracking = () => {
  const pathname = usePathname();

  return useCallback(
    (type: string, extraArgs = {}) => {
      const data = {
        path: pathname,
        queryParams: getQueryParams(),
        type,
        ...extraArgs,
      };

      sendEpisodEvent({
        event_name: EventType.UserAction,
        event_details: data,
      });
    },
    [pathname]
  );
};

export const useContextTracking = () => {
  return useCallback((context: Record<string, any>) => {
    setEpisodContext({
      event_details: context,
    });
  }, []);
};
